export default __webpack_public_path__ + "static/media/black.0db02cb5.jpeg";